module.exports = __webpack_public_path__ + "img/sudoku_explanation_4.88384313.png";